import angular from 'angular';
import LicenseRenewalWidgetComponent from './license-renewal-widget-component';
import linkToLicenseRenewalFormMmodule from './components/link-to-license-renewal-form/link-to-license-renewal-form-module';

export default angular
  .module('license-renewal-widget', [linkToLicenseRenewalFormMmodule.name])
  .component('licenseRenewalWidget', new LicenseRenewalWidgetComponent());



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/license-renewal/license-renewal-widget-module.js